import { render, staticRenderFns } from "./SchedulingHours.vue?vue&type=template&id=5a22563c&scoped=true"
import script from "./SchedulingHours.vue?vue&type=script&lang=js"
export * from "./SchedulingHours.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.4.27_cache-loader@4.1.0_webpack@4.47.0__css-loader@3.6_bsee5fwwgi4baxsb37pouy7wkq/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a22563c",
  null
  
)

export default component.exports